/* custom-product-page.js
   Save this file to your theme's /assets folder as
   "custom-product-page.js" -- the section loads it via asset_url. */

window.CustomProductPage = (function () {
  function formatMoney(cents, format) {
    // Basic fallback formatter; Shopify.formatMoney is available on most
    // themes because of money_format bootstrapping. Use it if present.
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents, format || window.Shopify.money_format);
    }
    return '£' + (cents / 100).toFixed(2);
  }

  function init(sectionId, variants) {
    var root = document.getElementById('cpp-' + sectionId);
    if (!root) return;

    var selectedOptions = [];
    var variantIdInput = document.getElementById('cpp-variant-id-' + sectionId);
    var priceEl = document.getElementById('cpp-price-' + sectionId);
    var addBtn = document.getElementById('cpp-add-' + sectionId);
    var sellingPlanInput = document.getElementById('cpp-selling-plan-' + sectionId);
    var qtyInput = document.getElementById('cpp-qty-' + sectionId);

    // --- Gallery thumbnails ---
    var mainImg = document.getElementById('cpp-main-img-' + sectionId);
    root.querySelectorAll('.cpp__thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        root.querySelectorAll('.cpp__thumb').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        if (mainImg) mainImg.src = thumb.getAttribute('data-full');
      });
    });

    // --- Quantity stepper ---
    root.querySelectorAll('.cpp__qty-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var current = parseInt(qtyInput.value, 10) || 1;
        var next = btn.getAttribute('data-qty') === 'plus' ? current + 1 : Math.max(1, current - 1);
        qtyInput.value = next;
      });
    });

    // --- Variant option pills ---
    var optionGroups = root.querySelectorAll('.cpp__option-values');
    optionGroups.forEach(function (group) {
      var idx = parseInt(group.getAttribute('data-option-index'), 10);
      var selected = group.querySelector('.is-selected');
      selectedOptions[idx] = selected ? selected.getAttribute('data-value') : null;

      group.querySelectorAll('.cpp__option-pill').forEach(function (pill) {
        pill.addEventListener('click', function () {
          group.querySelectorAll('.cpp__option-pill').forEach(function (p) { p.classList.remove('is-selected'); });
          pill.classList.add('is-selected');
          selectedOptions[idx] = pill.getAttribute('data-value');
          updateVariant();
        });
      });
    });

    function updateVariant() {
      var match = variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selectedOptions[i]; });
      });
      if (!match) return;

      variantIdInput.value = match.id;

      if (priceEl) {
        var currentEl = priceEl.querySelector('.cpp__price-current');
        var compareEl = priceEl.querySelector('.cpp__price-compare');
        var saveEl = priceEl.querySelector('.cpp__price-save');
        if (currentEl) currentEl.textContent = formatMoney(match.price);
        if (match.compare_at_price && match.compare_at_price > match.price) {
          if (compareEl) { compareEl.textContent = formatMoney(match.compare_at_price); compareEl.style.display = ''; }
          if (saveEl) {
            var pct = Math.round(((match.compare_at_price - match.price) / match.compare_at_price) * 100);
            saveEl.textContent = pct + '% off';
            saveEl.style.display = '';
          }
        } else {
          if (compareEl) compareEl.style.display = 'none';
          if (saveEl) saveEl.style.display = 'none';
        }
      }

      if (addBtn) {
        if (match.available) {
          addBtn.disabled = false;
          addBtn.textContent = 'Add to bag';
        } else {
          addBtn.disabled = true;
          addBtn.textContent = 'Sold out';
        }
      }
    }

    // --- Subscribe & Save radios ---
    root.querySelectorAll('input[name="purchase_option"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (!sellingPlanInput) return;
        sellingPlanInput.value = radio.value === 'onetime' ? '' : radio.getAttribute('data-selling-plan-id') || radio.value;
      });
    });

    // --- Testimonials carousel arrows ---
    var track = document.getElementById('cpp-testimonials-track-' + sectionId);
    if (track) {
      var prevBtn = root.querySelector('[data-carousel-prev]');
      var nextBtn = root.querySelector('[data-carousel-next]');
      var scrollByCard = function (dir) {
        var card = track.querySelector('.cpp__testimonial');
        var amount = card ? card.getBoundingClientRect().width + 20 : 320;
        track.scrollBy({ left: dir * amount, behavior: 'smooth' });
      };
      if (prevBtn) prevBtn.addEventListener('click', function () { scrollByCard(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { scrollByCard(1); });
    }

    // --- FAQ "Show more questions" ---
    var faqMoreBtn = document.getElementById('cpp-faq-more-' + sectionId);
    var faqList = document.getElementById('cpp-faq-list-' + sectionId);
    if (faqMoreBtn && faqList) {
      faqMoreBtn.addEventListener('click', function () {
        faqList.querySelectorAll('.cpp__faq-item--extra.is-hidden').forEach(function (item) {
          item.classList.remove('is-hidden');
        });
        faqMoreBtn.style.display = 'none';
      });
    }

    // --- AJAX add to cart ---
    var form = root.querySelector('#cpp-form') || root.querySelector('form[action*="/cart/add"]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var formData = new FormData(form);
        addBtn.disabled = true;
        var originalText = addBtn.textContent;
        addBtn.textContent = 'Adding...';

        fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { Accept: 'application/json' }
        })
          .then(function (res) {
            if (!res.ok) throw new Error('Add to cart failed');
            return res.json();
          })
          .then(function () {
            addBtn.textContent = 'Added OK';
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            setTimeout(function () {
              addBtn.textContent = originalText;
              addBtn.disabled = false;
            }, 1600);
          })
          .catch(function () {
            addBtn.textContent = 'Something went wrong';
            setTimeout(function () {
              addBtn.textContent = originalText;
              addBtn.disabled = false;
            }, 1800);
          });
      });
    }
  }

  return { init: init };
})();